import {
  INVENTORY_LOCATION_LIST_REQUESTING,
  LIST_INVENTORY_LOCATIONS_SUCCESS,
  RESET_INVENTORY_LOCATION_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  isListFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_INVENTORY_LOCATION_ISFETCHING: {
      return {
        ...state,
        isListFetching: false
      };
    }
    case INVENTORY_LOCATION_LIST_REQUESTING: {
      return {
        ...state,
        isListFetching: true
      };
    }
    case LIST_INVENTORY_LOCATIONS_SUCCESS: {
      const data = { ...state.data };
      action.payload.forEach((object) => {
        data[object.id] = object;
      });
      return {
        data,
        isListFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
